import React from 'react'
import { createRoot } from 'react-dom/client'
import 'sanitize.css'
import 'react-toastify/dist/ReactToastify.css'
import 'rc-tooltip/assets/bootstrap_white.css'

import './index.css'

import App from './app.jsx'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
